/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {message, Table} from 'antd'
import $ from 'jquery'
import HeaderTable from '../BaseComponent/HeaderTable'
import Page from '../../Component/Pagination/Pagination'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import cookie from 'react-cookies'
import BASE_REPORT from '../BaseComponent/BASEREPORT'
import BASE_MANAGE from '../BaseComponent/BASEMANAGE'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Filter from '../BaseComponent/Filter'

class Variable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      variable: [],
      modalEdit: false,
      printInfo: [],
      columns: []
    }
  }

  reportVariable = (
    pageNumber = sessionStorage.getItem('pageNumber'),
    pageSize = sessionStorage.getItem('dropDownVal'),
    params = sessionStorage.getItem('params')
  ) => {
    http
      .get(
        `${BASE_REPORT.BASE_REPORT_VARIABLE}?export=false&pageSize=${pageSize}&pageNumber=${pageNumber}&${params}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          // alert(JSON.stringify(response.data))
          let data = response.data.object.result

          this.setState({
            variable: response.data.object.result,
            countAll: response.data.object.countAll
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')

    this.reportVariable()
  }

  onResultFetched(data) {
    this.setState({
      variable: data
    })
  }

  changeDropDown(data) {
    this.setState({
      variable: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  toggleEdit = () => {
    this.cancelEdit()
  }
  openEdit = (id, title, value) => {
    this.setState({
      modalEdit: !this.state.modalEdit,
      title,
      value
    })
    sessionStorage.setItem('personId', id)
  }

  cancelEdit = () => {
    this.setState({
      modalEdit: !this.state.modalEdit,
      title: '',
      value: ''
    })
    sessionStorage.removeItem('personId')
  }
  confirmEdit = () => {
    let id = sessionStorage.getItem('personId')
    let title = document.getElementById('titleModal').value
    let value = document.getElementById('valueModal').value
    let titleError = false
    let valueError = false
    let formError = false
    if (title == '') {
      titleError = true
      formError = true
      message.error('عنوان وارد شود')
    } else {
      if (!titleError) {
        this.setState({error: ''})
      }
    }
    if (value == '') {
      valueError = true
      formError = true
      message.error('مقدار وارد شود')
    } else {
      if (!valueError) {
        this.setState({error: ''})
      }
    }
    if (!formError) {
      let data = {
        id: id,
        title: title,
        value: value
      }
      http.post(`${BASE_MANAGE.BASE_MANAGE_SYSTEM_EDIT_VARIABLE}`, data, {}).then((response) => {
        if (response.data.error == null) {
          this.reportVariable()

          message.success('ویرایش با موفقیت انجام شد')
          this.setState({
            modalEdit: !this.state.modalEdit
          })
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          this.setState({
            modalEdit: !this.state.modalEdit
          })
        }
      })
    }
  }

  filter(data, countAll) {
    this.setState({
      variable: data,
      countAll
    })
  }

  exportExcel = () => {
    http
      .get(
        `${BASE_REPORT.BASE_REPORT_VARIABLE}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(`${BASE_REPORT.BASE_REPORT_VARIABLE}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')

    let excelColumns = [
      {label: 'عنوان', value: 'title'},
      {label: 'نوع', value: 'type'},
      {label: 'مقدار', value: 'value'}
    ]

    var printCol = ['ردیف', 'عنوان', 'نوع', 'مقدار']

    return (
      <div className="rtl printA4Page">
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش متغیر های سیستمی.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'title'}
                field={'title'}
                title={'عنوان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'type'}
                field={'type'}
                title={'نوع'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'value'}
                field={'value'}
                title={'مقدار'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش متغیر های سیستمی"
              headerColSpan={4}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={3}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((variable, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{variable.title}</td>
                  <td>{variable.type}</td>
                  <td>{variable.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>متغیر های سیستمی</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  url={BASE_REPORT.BASE_REPORT_VARIABLE}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl=""
                  printLink=""
                  printComponent={this.printTable}
                  titleAdd=""
                  execelUrl={BASE_REPORT.BASE_REPORT_VARIABLE + '?export=true'}
                  excelColumns={excelColumns}
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>

            <Filter
              urlFilter={BASE_REPORT.BASE_REPORT_VARIABLE}
              filter={this.filter.bind(this)}
              typeVariable={true}
              title={true}
              valueVariable={true}
            />

            {this.state.variable.length > 0 ? (
              <div className="showBaseTable">
                <table className="baseTable">
                  <tbody>
                    <tr>
                      <td>ردیف</td>
                      <td>عنوان</td>
                      <td>نوع</td>
                      <td>مقدار</td>
                      <td>ویرایش</td>
                    </tr>
                    {this.state.variable.map((variable, index) => (
                      <tr>
                        <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                        <td>{variable.title}</td>
                        <td>{variable.type}</td>
                        <td>{variable.value}</td>
                        <td>
                          <button
                            onClick={() => this.openEdit(variable.id, variable.title, variable.value)}
                            className="center btnTd"
                            style={{textAlign: 'center !important'}}
                          >
                            <img className={'btnImage'} src={require('../../image/editDriver.svg')} alt={''} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="paginationWrapp">
                  <Page
                    defaultCurrent={1}
                    total={this.state.countAll}
                    urlParams={sessionStorage.getItem('params')}
                    onResultFetched={this.onResultFetched.bind(this)}
                    url={BASE_REPORT.BASE_REPORT_VARIABLE}
                  />
                </div>
              </div>
            ) : (
              ''
            )}
          </div>

          <Modal isOpen={this.state.modalEdit} toggle={this.toggleEdit} size="sm">
            <ModalHeader toggle={this.toggleEdit}>ویرایش</ModalHeader>
            <ModalBody>
              <div className="modalForm">
                <div className="formComponent">
                  <label>عنوان</label>
                  <input
                    type="text"
                    id="titleModal"
                    defaultValue={this.state.title}
                    name="title"
                    className="form-control"
                  />
                </div>
                <div className="formComponent">
                  <label>مقدار</label>
                  <textarea
                    id="valueModal"
                    name="value"
                    defaultValue={this.state.value}
                    className="form-control"
                    style={{minHeight: '200px'}}
                  />
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <button className="confirmBtnModal" onClick={this.confirmEdit}>
                اعمال تغییرات
              </button>
              <button className="cancelBtnModal" onClick={this.cancelEdit}>
                لغو
              </button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

export default Variable
